import { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Fab,
  IconButton,
  MenuItem,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../../context/AuthContext";
import { GrabsContext } from "../../../context/GrabsContext";
import PageContent from "../../../component/PageContent";
import { useTheme } from "@emotion/react";
import usePullRequests from "../../../customHooks/usePullRequests";
import TextFieldDebounced from "../../../component/TextFieldDebounced";
import InfiniteScrollerTable from "../../../component/InfiniteScroller/InfiniteScrollerTable";
import ListFooter from "../../../component/InfiniteScroller/ListFooter";
import momentPhoenix from "../../../helpers/momentPhoenix";
//
const PullRequests = () => {
  const navigate = useNavigate();
  const { authToken, isMaterialAppAdmin } = useContext(AuthContext);
  const { clearGrabs } = useContext(GrabsContext);
  const {
    searchQuery,
    setSearchQuery,
    status,
    setStatus,
    results,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  } = usePullRequests(authToken, 25, "open");
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <PageContent>
      <h2
        style={{
          textAlign: "center",
        }}
      >
        Pull Requests
      </h2>
      <div
        style={{
          display: "flex",
          position: "relative",
          flexDirection: isSmallScreen ? "column" : "row",
          marginTop: 16,
          paddingLeft: 16,
          paddingRight: 16,
          marginBottom: "16px",
          justifyContent: isSmallScreen ? "center" : "flex-end",
        }}
      >
        <TextField
          size="small"
          fullWidth={isSmallScreen}
          sx={{
            width: isSmallScreen ? "100%" : 200,
            marginRight: isSmallScreen ? 0 : "8px",
            marginTop: isSmallScreen ? "8px" : 0,
          }}
          select
          variant="outlined"
          label="Status"
          value={status}
          onChange={(e) => setStatus(e.target.value)}
        >
          <MenuItem value={"all"}>All</MenuItem>
          <MenuItem value={"open"}>Open</MenuItem>
          <MenuItem value={"pending"}>Pending</MenuItem>
        </TextField>
        <TextFieldDebounced
          placeholder="search..."
          value={searchQuery}
          size="small"
          sx={{
            width: isSmallScreen ? "100%" : 200,
            marginRight: isSmallScreen ? 0 : "8px",
            marginTop: isSmallScreen ? "8px" : 0,
          }}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
        {isMaterialAppAdmin() && (
          <Button
            variant="outlined"
            style={{
              width: isSmallScreen ? "100%" : 200,
            }}
            onClick={() => {
              clearGrabs();
              navigate("/pull-requests/new");
            }}
          >
            + New
          </Button>
        )}
      </div>

      <InfiniteScrollerTable
        TableContainerComponent={Paper}
        TableStyle={{ minWidth: "650px" }}
        TableHead={() => (
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>

              <TableCell
                sx={{
                  minWidth: "150px",
                  maxWidth: "200px",
                  textOverflow: "ellipsis",
                }}
              >
                Job
              </TableCell>
              <TableCell>Requested By</TableCell>
              {/* <TableCell>Pulled By</TableCell> */}
              <TableCell>ID</TableCell>
              <TableCell>Status</TableCell>

              {/* <TableCell>Posted</TableCell> */}
            </TableRow>
          </TableHead>
        )}
        items={results}
        renderRow={(item, index) => {
          return (
            <TableRow
              onClick={() => navigate(`/pull-requests/${item.id}`)}
              key={index}
              sx={{
                // "& td": { border: 0 },
                cursor: "pointer",
                "&:hover": {
                  background:
                    theme.palette.mode == "dark"
                      ? theme.palette.primary.dark
                      : theme.palette.secondary.light,
                },
              }}
            >
              <TableCell>
                {momentPhoenix(item.created_on).format("MM/DD/YY hh:mm A z")}
              </TableCell>

              <TableCell
                sx={{
                  minWidth: "150px",
                  maxWidth: "200px",
                  textOverflow: "ellipsis",
                }}
              >
                {item.job_name
                  ? `${item.projectid} - ${item.job_name}`
                  : "[UNLISTED]"}
              </TableCell>
              <TableCell>{item.user_full_name}</TableCell>
              {/* <TableCell>{item.transferred_by_full_name}</TableCell> */}
              <TableCell>{item.transactionid}</TableCell>
              <TableCell>{item.status_description}</TableCell>

              {/* <TableCell>
                {item.approved_on
                  ? "Yes"
                  : item.rejected_on
                  ? "Rejected"
                  : "No"}
              </TableCell> */}
            </TableRow>
          );
        }}
        onRefresh={onRefresh}
        onEndReached={onLoadMore}
        loading={refreshing || loadingMore}
        ListFooterComponent={() => {
          return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
        }}
      />
    </PageContent>
  );
};

export default PullRequests;
